var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBarChartRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 9.07129C17.5756 9.07154 18.2207 9.73458 18.2207 10.543V20.2471C18.2207 21.0556 17.5756 21.7185 16.7705 21.7188H14.8486C14.0435 21.7186 13.3985 21.0557 13.3984 20.2471V10.543C13.3984 9.73452 14.0435 9.07144 14.8486 9.07129H16.7705ZM23.2988 7.84961C24.1041 7.84961 24.75 8.51257 24.75 9.32129V20.2471C24.75 21.0558 24.1041 21.7188 23.2988 21.7188H21.3779C20.5727 21.7186 19.9277 21.0557 19.9277 20.2471V9.32129C19.9277 8.51264 20.5727 7.84972 21.3779 7.84961H23.2988ZM3.71191 11.8926C4.51697 11.8927 5.16195 12.5558 5.16211 13.3643V20.2324C5.16201 21.041 4.51701 21.7039 3.71191 21.7041H1.79004C0.984998 21.7039 0.33994 21.0409 0.339844 20.2324V13.3643C0.340002 12.5558 0.985037 11.8928 1.79004 11.8926H3.71191ZM10.2412 10.4746C11.0463 10.4748 11.6913 11.1377 11.6914 11.9463V20.2324C11.6913 21.0409 11.0463 21.7039 10.2412 21.7041H8.31934C7.51426 21.7039 6.86924 21.0409 6.86914 20.2324V11.9463C6.8692 11.1377 7.51424 10.4748 8.31934 10.4746H10.2412Z",
    fill: "#0A66C2",
    stroke: "#0A66C2",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarChartRevenue);
export default __webpack_public_path__ + "static/media/icon_bar_chart_revenue.751b028279ca3a8a5200fe62f6617f5d.svg";
export { ForwardRef as ReactComponent };